<template>
  <filter-template @submit="filter()">
    <v-row>
      <v-col
        cols="12"
        sm12
      >
        <div
          class="headerSubtitle1"
        >
          Dados da pergunta
        </div>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="payload.search"
          required
          placeholder="Buscar"
          outlined
          :rules="[maxLength(30)]"
          type="text"
          class="user-field"
          append-icon="mdi-magnify"
          clearable
        />
      </v-col>
      <v-col
        cols="12"
        sm12
      >
        <v-select
          v-model="payload.categoryId"
          :items="categories"
          label="Categoria"
          item-text="name"
          item-value="id"
          outlined
          clearable
        />
      </v-col>
      <v-col cols="12">
        <input-select
          id="input:isPreLogin"
          v-model="payload.isPreLogin"
          label="Pré-login"
          :items="preLoginOptions"
          clearable
        />
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterTemplate from 'Arch/components/crud/components/FilterTemplate.vue';
import FilterMixin from 'Arch/components/crud/crud-mixins/FilterMixin';
import RulesMixin from 'Arch/mixins/RulesMixin';
import CategoriesRequest from 'Modules/contacard/faq/categories/CategoriesRequest';
import NotificationMixin from 'Arch/mixins/NotificationMixin';

export default {
  name: 'QuestionsFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin, RulesMixin, NotificationMixin],
  data() {
    return {
      payload: {
        categoryId: null,
        search: null,
        isPreLogin: '',
      },
      categories: null,
      preLoginOptions: [
        {
          value: true,
          text: 'Sim',
        },
        {
          value: false,
          text: 'Não',
        },
      ],
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      CategoriesRequest.list()
        .then((response) => {
          const { data } = response;
          this.categories = data.data;
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    },
  },
};
</script>
<style scoped>
.row {
  flex: unset !important
}
</style>
